import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => (
  <div className="min-h-screen flex items-center justify-center px-6 pt-28 pb-20">
    <div className="max-w-lg w-full bg-cream border-t-2 border-gold p-12 text-center">
      <XCircle className="w-14 h-14 text-mocha mx-auto mb-5" />
      <h1 className="font-serif text-4xl text-espresso">Payment cancelled</h1>
      <p className="mt-4 text-mocha">No charge was made. Your bag is still saved — you can complete your order whenever you're ready.</p>
      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/checkout" className="px-8 py-3.5 bg-espresso text-ivory text-xs tracking-[0.18em] uppercase hover:bg-gold transition-colors">Return to Checkout</Link>
        <Link to="/shop" className="px-8 py-3.5 border border-espresso text-espresso text-xs tracking-[0.18em] uppercase hover:bg-espresso hover:text-ivory transition-colors">Store</Link>
      </div>
    </div>
  </div>
);

export default PaymentCancel;
